import gsap from 'gsap';

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { isMobile } from '../_app/cuchillo/core/Basics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';

export class ScrollItem__NoHide extends ScrollItem__BlockDefault {
    hasHiddenEnabled = false;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }
}

Scroll._registerClass('BlockNoHide', ScrollItem__NoHide);
